import { getConversationById } from '@app/helpers'
import { ConversationItem } from '@app/models'

import { ChatState } from '../types'

export const onFetchMessagesError = (
  state: ChatState,
  id: number
): ChatState => {
  const conversation = getConversationById(state.conversations, id)
  if (!conversation) {
    return state
  }

  const conversations: Record<number, ConversationItem> = {
    ...state.conversations,
    [id]: { ...conversation, fetching: 'ERROR' },
  }

  return {
    ...state,
    conversations,
  }
}
